module.exports = __webpack_public_path__ + "static/media/coloured-paper-bundle.b914d0fb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coloured-paper-bundle.svg
// module id = 471
// module chunks = 0